<div class="shimmer">
    <ng-container *ngFor="let item of [].constructor(4)">
        <div class="shimmer-row">
            <span class="skeleton shimmer-title"></span>
            <span class="skeleton shimmer-value"></span>
        </div>
    </ng-container>
</div>
<div class="skeleton-main">
    <div class="squire skeleton"></div>
</div>
